







































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class PaywallGiftGroups extends Vue {
  @Prop(Object) private readonly groupPlan!: object | undefined;
}
